import { ProfileFormValues } from './utils'
import { Supplier, SupplierInput } from 'EstraSuppliers'
import { formatApiStringToDate, formatDateToApiString } from 'app/utils/date'
export const joinApiDataToLocalValues = (
  apiData: Supplier,
  localValues: ProfileFormValues
): ProfileFormValues => {
  const formValues: ProfileFormValues = {
    // Azienda
    company_name:
      apiData.company_name || localValues.company_name || apiData.name,
    company_type: apiData.company_type || localValues.company_type || undefined,
    company_fiscal_code:
      apiData.company_fiscal_code || localValues.company_fiscal_code,
    company_vat: apiData.company_vat || localValues.company_vat,
    company_activity: apiData.company_activity || localValues.company_activity,
    company_cciaa_nr: apiData.company_cciaa_nr || localValues.company_cciaa_nr,
    company_cciaa_date:
      formatApiStringToDate(apiData.company_cciaa_date) ||
      localValues.company_cciaa_date ||
      null,
    company_date_start:
      formatApiStringToDate(apiData.company_date_start) ||
      localValues.company_date_start ||
      null,
    company_minimum_tax:
      apiData.company_minimum_tax || localValues.company_minimum_tax,
    flat_rate_vat: apiData.flat_rate_vat || localValues.flat_rate_vat,
    company_withholding_tax:
      apiData.company_withholding_tax || localValues.company_withholding_tax,

    // Contatti
    company_address_street:
      apiData.company_address_street || localValues.company_address_street,
    company_address_number:
      apiData.company_address_number || localValues.company_address_number,
    company_postal_code:
      apiData.company_postal_code || localValues.company_postal_code,
    company_province_id:
      apiData.company_province?.id.toString() ||
      localValues.company_province_id,
    company_city_id:
      apiData.company_city?.id.toString() || localValues.company_city_id,
    phone: apiData.phone || localValues.phone,
    company_mobile_number:
      apiData.company_mobile_number || localValues.company_mobile_number,
    company_fax_number:
      apiData.company_fax_number || localValues.company_fax_number,
    company_pec: apiData.company_pec || localValues.company_pec,
    email: apiData.email || localValues.email,
    company_dm_letters:
      apiData.company_dm_letters || localValues.company_dm_letters,

    // Certificazioni
    standard_iso_9001:
      apiData.standard_iso_9001 || localValues.standard_iso_9001,
    standard_iso_14001:
      apiData.standard_iso_14001 || localValues.standard_iso_14001,
    standard_ohsas18001:
      apiData.standard_ohsas18001 || localValues.standard_ohsas18001,
    standard_iso_45001:
      apiData.standard_iso_45001 || localValues.standard_iso_45001,
    standard_iso_iec_27001:
      apiData.standard_iso_iec_27001 || localValues.standard_iso_iec_27001,
    standard_sa8000: apiData.standard_sa8000 || localValues.standard_sa8000,
    standard_other: apiData.standard_other || localValues.standard_other,

    // Indirizzo Corrispondenza
    fill_company_secondary_address:
      Boolean(apiData.company_secondary_address_street) ||
      localValues.fill_company_secondary_address,
    company_secondary_address_street:
      apiData.company_secondary_address_street ||
      localValues.company_secondary_address_street,
    company_secondary_address_number:
      apiData.company_secondary_address_number ||
      localValues.company_secondary_address_number,
    company_secondary_postal_code:
      apiData.company_secondary_postal_code ||
      localValues.company_secondary_postal_code,
    company_secondary_province_id:
      apiData.company_secondary_province?.id.toString() ||
      localValues.company_secondary_province_id,
    company_secondary_city_id:
      apiData.company_secondary_city?.id.toString() ||
      localValues.company_secondary_city_id,

    // Titolare
    holder_address: {
      name: apiData.holder_address?.name || localValues.holder_address.name,
      surname:
        apiData.holder_address?.surname || localValues.holder_address.surname,
      fiscal_code:
        apiData.holder_address?.fiscal_code ||
        localValues.holder_address.fiscal_code,
      birth_date:
        formatApiStringToDate(apiData.holder_address?.birth_date) ||
        localValues.holder_address.birth_date,
      birth_place:
        apiData.holder_address?.birth_place ||
        localValues.holder_address.birth_place,
      address_street:
        apiData.holder_address?.address_street ||
        localValues.holder_address.address_street,
      address_number:
        apiData.holder_address?.address_number ||
        localValues.holder_address.address_number,
      postal_code:
        apiData.holder_address?.postal_code ||
        localValues.holder_address.postal_code,
      province_id:
        apiData.holder_address?.province?.id.toString() ||
        localValues.holder_address.province_id,
      city_id:
        apiData.holder_address?.city?.id.toString() ||
        localValues.holder_address.city_id,
    },

    // TECHNICAL DIRECTOR
    fill_technical_director:
      Boolean(apiData.technical_director_address?.name) ||
      localValues.fill_technical_director,
    technical_director_address: {
      name:
        apiData.technical_director_address?.name ||
        localValues.technical_director_address.name,
      surname:
        apiData.technical_director_address?.surname ||
        localValues.technical_director_address.surname,
      fiscal_code:
        apiData.technical_director_address?.fiscal_code ||
        localValues.technical_director_address.fiscal_code,
      birth_date:
        formatApiStringToDate(apiData.technical_director_address?.birth_date) ||
        localValues.technical_director_address.birth_date,
      birth_place:
        apiData.technical_director_address?.birth_place ||
        localValues.technical_director_address.birth_place,
      address_street:
        apiData.technical_director_address?.address_street ||
        localValues.technical_director_address.address_street,
      address_number:
        apiData.technical_director_address?.address_number ||
        localValues.technical_director_address.address_number,
      postal_code:
        apiData.technical_director_address?.postal_code ||
        localValues.technical_director_address.postal_code,
      province_id:
        apiData.technical_director_address?.province?.id.toString() ||
        localValues.technical_director_address.province_id,
      city_id:
        apiData.technical_director_address?.city?.id.toString() ||
        localValues.technical_director_address.city_id,
    },

    // TECHNICAL MANAGER
    fill_technical_manager:
      Boolean(apiData.technical_manager_address?.name) ||
      localValues.fill_technical_manager,
    technical_manager_address: {
      name:
        apiData.technical_manager_address?.name ||
        localValues.technical_manager_address.name,
      surname:
        apiData.technical_manager_address?.surname ||
        localValues.technical_manager_address.surname,
      fiscal_code:
        apiData.technical_manager_address?.fiscal_code ||
        localValues.technical_manager_address.fiscal_code,
      birth_date:
        formatApiStringToDate(apiData.technical_manager_address?.birth_date) ||
        localValues.technical_manager_address.birth_date,
      birth_place:
        apiData.technical_manager_address?.birth_place ||
        localValues.technical_manager_address.birth_place,
      address_street:
        apiData.technical_manager_address?.address_street ||
        localValues.technical_manager_address.address_street,
      address_number:
        apiData.technical_manager_address?.address_number ||
        localValues.technical_manager_address.address_number,
      postal_code:
        apiData.technical_manager_address?.postal_code ||
        localValues.technical_manager_address.postal_code,
      province_id:
        apiData.technical_manager_address?.province?.id.toString() ||
        localValues.technical_manager_address.province_id,
      city_id:
        apiData.technical_manager_address?.city?.id.toString() ||
        localValues.technical_manager_address.city_id,
    },

    // Coordinate bancarie primarie
    bank_account_1: {
      bank: apiData.bank_account_1?.bank || localValues.bank_account_1.bank,
      agency:
        apiData.bank_account_1?.agency || localValues.bank_account_1.agency,
      iban: apiData.bank_account_1?.iban || localValues.bank_account_1.iban,
      delegated_name:
        apiData.bank_account_1?.delegated_name ||
        localValues.bank_account_1.delegated_name,
      delegated_surname:
        apiData.bank_account_1?.delegated_surname ||
        localValues.bank_account_1.delegated_surname,
      delegated_fiscal_code:
        apiData.bank_account_1?.delegated_fiscal_code ||
        localValues.bank_account_1.delegated_fiscal_code,
      delegated_role:
        apiData.bank_account_1?.delegated_role ||
        localValues.bank_account_1.delegated_role,
    },

    // Coordinate bancarie secondarie
    fill_secondary_bank_account:
      Boolean(apiData.bank_account_2?.bank) ||
      localValues.fill_secondary_bank_account,
    bank_account_2: {
      bank: apiData.bank_account_2?.bank || localValues.bank_account_2.bank,
      agency:
        apiData.bank_account_2?.agency || localValues.bank_account_2.agency,
      iban: apiData.bank_account_2?.iban || localValues.bank_account_2.iban,
      delegated_name:
        apiData.bank_account_2?.delegated_name ||
        localValues.bank_account_2.delegated_name,
      delegated_surname:
        apiData.bank_account_2?.delegated_surname ||
        localValues.bank_account_2.delegated_surname,
      delegated_fiscal_code:
        apiData.bank_account_2?.delegated_fiscal_code ||
        localValues.bank_account_2.delegated_fiscal_code,
      delegated_role:
        apiData.bank_account_2?.delegated_role ||
        localValues.bank_account_2.delegated_role,
    },

    // Privacy
    privacy_required: apiData.privacy_required || localValues.privacy_required,
    privacy_optional_internal_marketing:
      apiData.privacy_optional_internal_marketing != null
        ? apiData.privacy_optional_internal_marketing
        : localValues.privacy_optional_internal_marketing,
    privacy_optional_external_marketing:
      apiData.privacy_optional_external_marketing != null
        ? apiData.privacy_optional_external_marketing
        : localValues.privacy_optional_external_marketing,
  }

  return formValues
}

export const transformFormValueInApiInput = (
  formValues: ProfileFormValues
): SupplierInput => {
  const inputData: SupplierInput = {
    // Azienda
    company_name: formValues.company_name,
    company_type: formValues.company_type,
    company_fiscal_code: formValues.company_fiscal_code,
    company_vat: formValues.company_vat,
    company_activity: formValues.company_activity,
    company_cciaa_nr: formValues.company_cciaa_nr,
    company_cciaa_date: formatDateToApiString(formValues.company_cciaa_date),
    company_date_start: formatDateToApiString(formValues.company_date_start),
    company_minimum_tax: formValues.company_minimum_tax,
    flat_rate_vat: formValues.flat_rate_vat,
    company_withholding_tax: formValues.company_withholding_tax,

    // Contatti
    company_address_street: formValues.company_address_street,
    company_address_number: formValues.company_address_number,
    company_postal_code: formValues.company_postal_code,
    company_province_id: formValues.company_province_id,
    company_city_id: formValues.company_city_id,
    phone: formValues.phone,
    company_mobile_number: formValues.company_mobile_number,
    company_fax_number: formValues.company_fax_number,
    company_pec: formValues.company_pec,
    email: formValues.email,

    // Certificazioni
    company_dm_letters: formValues.company_dm_letters,
    standard_iso_9001: formValues.standard_iso_9001,
    standard_iso_14001: formValues.standard_iso_14001,
    standard_ohsas18001: formValues.standard_ohsas18001,
    standard_iso_45001: formValues.standard_iso_45001,
    standard_iso_iec_27001: formValues.standard_iso_iec_27001,
    standard_sa8000: formValues.standard_sa8000,
    standard_other: formValues.standard_other,

    // Indirizzo Secondario
    fill_company_secondary_address: formValues.fill_company_secondary_address,
    company_secondary_address_street:
      formValues.company_secondary_address_street,
    company_secondary_address_number:
      formValues.company_secondary_address_number,
    company_secondary_postal_code: formValues.company_secondary_postal_code,
    company_secondary_province_id: formValues.company_secondary_province_id,
    company_secondary_city_id: formValues.company_secondary_city_id,

    // Titolare
    holder_address: {
      name: formValues.holder_address.name,
      surname: formValues.holder_address.surname,
      fiscal_code: formValues.holder_address.fiscal_code,
      birth_date: formatDateToApiString(formValues.holder_address.birth_date),
      birth_place: formValues.holder_address.birth_place,
      address_street: formValues.holder_address.address_street,
      address_number: formValues.holder_address.address_number,
      postal_code: formValues.holder_address.postal_code,
      province_id: formValues.holder_address.province_id,
      city_id: formValues.holder_address.city_id,
    },

    // Direttore tecnico
    technical_director_address: formValues.fill_technical_director
      ? {
          name: formValues.technical_director_address.name,
          surname: formValues.technical_director_address.surname,
          fiscal_code: formValues.technical_director_address.fiscal_code,
          birth_date: formatDateToApiString(
            formValues.technical_director_address.birth_date
          ),
          birth_place: formValues.technical_director_address.birth_place,
          address_street: formValues.technical_director_address.address_street,
          address_number: formValues.technical_director_address.address_number,
          postal_code: formValues.technical_director_address.postal_code,
          province_id: formValues.technical_director_address.province_id,
          city_id: formValues.technical_director_address.city_id,
        }
      : undefined,

    // Responsabile tecnico
    technical_manager_address: formValues.fill_technical_manager
      ? {
          name: formValues.technical_manager_address.name,
          surname: formValues.technical_manager_address.surname,
          fiscal_code: formValues.technical_manager_address.fiscal_code,
          birth_date: formatDateToApiString(
            formValues.technical_manager_address.birth_date
          ),
          birth_place: formValues.technical_manager_address.birth_place,
          address_street: formValues.technical_manager_address.address_street,
          address_number: formValues.technical_manager_address.address_number,
          postal_code: formValues.technical_manager_address.postal_code,
          province_id: formValues.technical_manager_address.province_id,
          city_id: formValues.technical_manager_address.city_id,
        }
      : undefined,

    // Banca primaria
    bank_account_1: {
      ...formValues.bank_account_1,
    },

    // Banca secondaria
    bank_account_2: formValues.fill_secondary_bank_account
      ? {
          ...formValues.bank_account_2,
        }
      : undefined,

    // Privacy
    privacy_required: formValues.privacy_required,
    privacy_optional_internal_marketing:
      formValues.privacy_optional_internal_marketing,
    privacy_optional_external_marketing:
      formValues.privacy_optional_external_marketing,
  }

  return inputData
}
